import { type SanityContentImage, type SanityContentVideo } from "@modules/common/cms/sanityType"
import { YouTubeVideoPlayer } from "@modules/utils/components/youTubeVideo"
import { PortableText, type PortableTextProps } from "@portabletext/react"

export const HUPortableText = ({ value }: PortableTextProps) => {
  const portableTextComponents = {
    list: {
      bullet: ({ children }: any) => <ul className="mb-4">{children}</ul>,
    },

    listItem: {
      bullet: ({ children }: any) => <li className="mb-2">{children}</li>,
      checkmarks: ({ children }: any) => <ol className="mb-4">{children}</ol>,
    },
    marks: {
      link: ({ value, children }: any) => {
        return (
          <a
            className="cursor-pointer underline"
            href={value?.href}
            target={"_blank"}
            rel="noreferrer"
            style={{ color: "var(--color-purple-500)" }}
          >
            {children}
          </a>
        )
      },
    },
    types: {
      content_image: ContentImage,
      content_video: ContentVideo,
    },
  }

  return <PortableText value={value} components={portableTextComponents} />
}

const ContentImage = (imageNode: { value: SanityContentImage }) => {
  const image = imageNode.value

  return <img src={image.uri} alt={image.alt_text} className="mx-auto my-4 block w-full rounded-4xl object-cover" />
}

const ContentVideo = (videoNode: { value: SanityContentVideo }) => {
  const articleVideo = videoNode.value

  return (
    <div className="my-4">
      <YouTubeVideoPlayer link={articleVideo.uri} width={480} height={270} />
    </div>
  )
}
